<template>
<div class="mt-2">
    <v-form ref="form" v-model="valid" lazy-validation>

        <template slot="progress">
            <v-progress-linear color="deep-purple" height="10" indeterminate></v-progress-linear>
        </template>

        <div class="row ">

            <div class="col-sm-6">
                <v-text-field v-model="data.firstname" label="ชื่อ" required outlined hide-details :rules="firstnameRules"></v-text-field>
            </div>
            <div class="col-sm-6">
                <v-text-field v-model="data.lastname" label="นามสกุล" required outlined hide-details :rules="lastnameRules"></v-text-field>
            </div>

        </div>

        <v-divider class="mt-5 mb-5"></v-divider>
        <div>
            <v-radio-group :rules="genderRules" v-model="data.gender" row hide-details>
                <label class="pr-3">เพศ : </label>
                <v-radio label="ชาย" value="M"></v-radio>
                <v-radio label="หญิง" value="F"></v-radio>
            </v-radio-group>

        </div>
        <v-divider class="mt-5 mb-5"></v-divider>

        <div class="mt-5 mb-3"> <b>วัน เดือน ปีเกิด</b></div>
        <div class="row">
            <div class="col-4">
                <v-autocomplete :rules="dateRules" outlined v-if="dateList" v-model="data.birthDate" :items="dateList" item-text="text" item-value="value" label="วันที่"></v-autocomplete>
            </div>
            <div class="col-4">
                <v-autocomplete :rules="monthRules" outlined v-if="monthList" v-model="data.birthMonth" :items="monthList" item-text="text" item-value="value" label="เดือน"></v-autocomplete>
            </div>
            <div class="col-4">
                <v-autocomplete :rules="yearRules" outlined v-if="yearList" v-model="data.birthYear" :items="yearList" item-text="text" item-value="value" label="ปีพ.ศ."></v-autocomplete>
            </div>
        </div>

        <v-divider class=" mb-5"></v-divider>

        <v-textarea :rules="addressRules" v-model="data.address" label="ที่อยู่ปัจุบันที่ติดต่อได้" required outlined></v-textarea>

        <div class="row">
            <div class="col-sm-6">
                <v-autocomplete :rules="provinceRules" outlined v-if="provinceList" v-model="data.province" :items="provinceList" item-text="text" item-value="value" label="จังหวัด" hide-details=""></v-autocomplete>

            </div>
            <div class="col-sm-6">
                <v-text-field :rules="zipcodeRules" v-model="data.zipcode" label="รหัสไปรษณีย์" required outlined hide-details maxlength="5" minlength="5"></v-text-field>
            </div>

        </div>

        <v-divider class="mt-5 mb-5"></v-divider>

        <div v-if="group_id==1">
            <v-autocomplete :rules="mcCodeRules" outlined v-if="dealerList" v-model="data.mc_code" :items="dealerList" item-text="title" item-value="mc_code" label="ร้านผู้จำหน่าย">
                <template v-slot:item="{ item }">
                    <div class="selectDealer">
                        <div class="dealerTitle">
                            {{item.title }}
                        </div>
                        <div class="dealerAddress">
                            <div>{{item.address}} จ.{{item.province}} {{item.zip}}</div>
                        </div>
                    </div>
                </template>
            </v-autocomplete>
        </div>

        <div v-if="group_id==2">
            <div class="mt-1">
                <v-text-field v-model="data.academy" label="สถานศึกษา" required outlined hide-details :rules="academyRules"></v-text-field>
            </div>
        </div>

        <div v-if="group_id==3"> 
            <v-autocomplete :rules="jobRules" outlined v-if="jobList" v-model="data.job" :items="jobList" item-text="text" item-value="value" label="อาขีพ">

            </v-autocomplete>

            <div class="mt-1">
                <v-text-field v-model="data.workplace" label="สถานที่ทำงาน / บจ. /หจก." required outlined hide-details :rules="workplaceRules"></v-text-field>
            </div>
        </div>

        <v-divider class="mt-5 mb-5"></v-divider>
        <div>
            <div>
                <b>เบอร์มือถือ </b></div>

            <InputMask mask="999 999-9999" v-model="data.phone" placeholder="" class="text-center" />
            <div class="small">ตัวอย่าง 099 999 9999</div>
            <div class="errorMsg" v-if="phoneMsg">
                <div> {{phoneMsg}} </div>
            </div>

            <div class="mt-2">**โปรดระบุหมายเลขมือถือที่ใช้งานได้ เพื่อใช้รับรหัส OTP </div>

        </div>

        <div class="mt-4 pt-2">
            <v-text-field type="password" v-model="data.password" label="ตั้งรหัสผ่านที่ต้องการ" required outlined :rules="passwordRules" style="width:200px"></v-text-field>
        </div>

        <div class="text-center mt-5">
            <v-btn :disabled="!valid" color="light-blue darken-4" class="mr-4" @click="validate" style="color:#ffffff;">
                ลงทะเบียน
            </v-btn>
        </div>

    </v-form>

    <v-dialog v-model="dialog" max-width="300">

        <v-card class="pt-5 pb-2 text-center">

            <v-card-text>หมายเลข <div>{{data.phone }}</div> เคยใช้สมัครไปแล้วค่ะ</v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" text @click="dialog = false">
                    ตกลง
                </v-btn>

            </v-card-actions>
        </v-card>
    </v-dialog>

</div>
</template>

<script>
export default {

    components: {

    },
    props: {

        group_id: null

    },

    data: () => ({
        valid: true,
        provinceList: null,
        dateList: null,
        monthList: null,
        yearList: null,
        dealerList: null,
        telephone: null,
        dialog: null,
        phoneMsg: '',

        jobList: null,
        data: {
            academy: null,
            group_id: null,
            workplace: null,
            gender: null,
            firstname: null,
            lastname: null,
            nickname: null,
            address: null,
            province: null,
            zipcode: null,
            phone: null,
            birthDate: null,
            birthMonth: null,
            birthYear: null,
            mc_code: null,
            password: null,
            job: null
        },

        firstnameRules: [
            v => !!v || 'โปรดระบุชื่อด้วยค่ะ'
        ],
        lastnameRules: [
            v => !!v || 'โปรดระบุนามสกุลด้วยค่ะ'
        ],
        genderRules: [
            v => !!v || 'โปรดระบุเพศด้วยค่ะ'
        ],
        genderRules: [
            v => !!v || 'โปรดระบุเพศด้วยค่ะ'
        ],
        dateRules: [
            v => !!v || 'โปรดระบุวันเกิดด้วยค่ะ'
        ],
        monthRules: [
            v => !!v || 'โปรดระบุเดือนเกิดด้วยค่ะ'
        ],

        yearRules: [
            v => !!v || 'โปรดระบุปีเกิดด้วยค่ะ'
        ],

        addressRules: [
            v => !!v || 'โปรดระบุที่อยู่ด้วยค่ะ'
        ],
        provinceRules: [
            v => !!v || 'โปรดระบุจังหวัดด้วยค่ะ'
        ],
        zipcodeRules: [
            v => !!v || 'โปรดระบุรหัสไปรษณีย์ด้วยค่ะ'
        ],

        phoneRules: [
            v => !!v || 'โปรดระบุเบอร์มือถือด้วยค่ะ'
        ],

        mcCodeRules: [
            v => !!v || 'โปรดระบุร้านผู้จำหน่ายด้วยค่ะ'
        ],

        jobRules: [
            v => !!v || 'โปรดระบุอาชีพด้วยค่ะ'
        ],

        workplaceRules: [
            v => !!v || 'โปรดระบุสถานที่ทำงานด้วยค่ะ'
        ],

        academyRules: [
            v => !!v || 'โปรดระบุสถานศึกษาด้วยค่ะ'
        ],
        passwordRules: [
            v => !!v || 'โปรดระบุรหัสผ่านที่ต้องการด้วยค่ะ',
            v => (v && v.length >= 6) || 'รหัสผ่านอย่างน้อย 6 ตัวค่ะ',
            v => /^[a-zA-Z0-9]*$/.test(v) || 'a-z หรือ ตัวเลขเท่านั้นค่ะ',

        ],

    }),

    computed: {

    },

    watch: {

        group_id(val) {
            this.data.group_id = val
        }

    },
    methods: {

        validate() {
            console.log(this.data.phone)
            this.data.phoneMsg = null
            this.$refs.form.validate()
            let $vm = this
            setTimeout(function () {
                if ($vm.valid == true) {
                    console.log(this.valid)
                    if ($vm.data.phone) {
                        console.log('OK')
                        $vm.checkMemberRegistered()
                    } else {
                        $vm.phoneMsg = 'โปรดระบุเบอร์มือถือด้วยค่ะ'
                    }
                }
            }, 100);
        },

        checkMemberRegistered() {

            let url = "member/checkRegistered";
            let $vm = this;
            const formData = this.$formData(
                this.data
            );

            this.$API
                .post(url, this.formData(formData))
                .then(function (res) {
                    $vm.checkApi(res);

                    if (res.data.checkAllow) {

                        $vm.$emit('complete', $vm.data)

                    } else {
                        $vm.dialog = true
                    }

                })
                .catch(function (error) {
                    console.log(error);
                });

        },

        getFormList() {

            let url = "misc/registerFormList";
            let $vm = this;
            this.$API
                .post(url, this.formData())
                .then(function (res) {
                    $vm.checkApi(res);
                    $vm.dateList = Object.values(res.data.date)
                    $vm.monthList = Object.values(res.data.month)
                    $vm.yearList = Object.values(res.data.year)
                    $vm.provinceList = Object.values(res.data.province)
                    if (res.data.dealer) {
                        $vm.dealerList = Object.values(res.data.dealer)
                    }
                    if (res.data.job) {
                        $vm.jobList = Object.values(res.data.job)
                    }

                })
                .catch(function (error) {
                    console.log(error);
                });

        },

    },
    created() {

        this.getFormList();
        this.data.group_id = this.group_id

    },
};
</script>
